module.exports = __webpack_public_path__ + "img/Timor-Leste.5b8aba75.gif";